<template>
    <div>
        <div class="line"></div>
        <br>
        <div class="flex-row" v-if="informes.length > 0">
            <div class="flex-col-2" v-for="item in informes" v-bind:key="item.Id">
                <v-btn color="info" @click="BaixarInforme(item)"><v-icon>mdi-arrow-down</v-icon>&nbsp; Ano base {{ item.AnoReferencia }}</v-btn>
            </div>

            <!-- <div class="flex-col-2">
                <v-btn color="info"><v-icon>mdi-arrow-down</v-icon>&nbsp; Ano base 2018</v-btn>
            </div>
            <div class="flex-col-2">
                <v-btn color="info"><v-icon>mdi-arrow-down</v-icon>&nbsp; Ano base 2018</v-btn>
            </div>
            <div class="flex-col-2">
                <v-btn color="info"><v-icon>mdi-arrow-down</v-icon>&nbsp; Ano base 2018</v-btn>
            </div> -->
        </div>
        <div class="flex-row" v-if="informes.length == 0">
            <br>
            <p>Informe de Rendimentos Ano Base {{ ano-1 }}: Previsão de Disponibilização em FEV/{{ ano }}.</p>
            <p>Caso não tenha se enquadrado nesta especificação, favor solicitar o informe de rendimentos através do e-mail: gesef_fiscal@previsul.com.br constando o nome do Favorecido e CNPJ/CPF.</p>
        </div>

        <v-overlay :value="fullLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>        
    </div>
</template>

<script>
    import Vue from 'vue'
    import { mapState, mapGetters } from 'vuex';
    import Helpers from "@/utilities/Helpers";

    export default {
        mixins: [Helpers],   
        data() {
            return {
                fullLoading: false,
                baseURL: Vue.prototype.$httpPortal.defaults.baseURL,
                informes: [],
                ano: 0
            }
        },
        methods:
        {
            carregarInformes()
            {
                this.fullLoading = true;
                let codigoCorretor = this.usuario.codCorretor;

                let url = "InformeRendimento/"+codigoCorretor;
                                
                Vue.prototype.$httpPortal.get(url)
                .then(res => {
                    console.log(res.data);
                    this.informes = res.data;
                    this.fullLoading = false;
                })
                .catch(ex => {
                    console.log(ex);
                    this.fullLoading = false;
                });                   
            },
            BaixarInforme(item)
            {
                let codigoCorretor = this.usuario.codCorretor;
                
                let url = this.baseURL + "InformeRendimento/Baixar/" + codigoCorretor + "/"+ item.AnoReferencia;
                window.open(url, "_blank");                  
            },
        },
        computed: {
        ...mapGetters("usuarioModule", { usuario: "getUsuario" })
        },
        mounted(){
            this.ano = new Date().getFullYear();  
            this.carregarInformes();
        },                 
    }
</script>
